import { Check } from 'lucide-react';
import { twMerge as cn } from 'tailwind-merge';
import type { PlatformRoleOption } from '../../constants/platformRoleOptions';

interface RoleMenuOptionProps {
  role: PlatformRoleOption;
  selected: boolean;
  checkClassName?: string;
}

export function RoleMenuOption({
  role,
  selected,
  checkClassName = 'text-accent',
}: RoleMenuOptionProps) {
  return (
    <div className="flex items-start gap-2">
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className="font-medium text-gray-900">{role.label}</span>
          <span className="shrink-0 text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded">
            {role.scope}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1.5 leading-relaxed">
          {role.description}
        </p>
      </div>
      {selected && (
        <Check className={cn('w-4 h-4 shrink-0 mt-0.5', checkClassName)} />
      )}
    </div>
  );
}
